import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'distance'
})
export class DistancePipe implements PipeTransform {

  transform(metres: number, accuracy: number): any {
    if (metres >= 1000) {
      return (metres/1000).toFixed(accuracy ? accuracy : 2) + 'km';
    } else {
      return metres.toFixed(accuracy ? accuracy : 2) + 'm';
    }
  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/distance.pipe.ts